<template>
  <div>
    <div class="profile-sec">
      <div class="profile">
        <!-- <img src="../icons/profilePic.svg" alt="default-pic" /> -->
        <img
          :src="imageUrl || defaultImage"
          class="profile-img"
          alt="profile"
        />
        <p>{{ username }}</p>
      </div>
      <div class="edit-btn" v-if="showEdit" @click="onClickedit">
        <p>Edit</p>
      </div>
    </div>
    <div class="edit-profile-container">
      <form class="profile-form">
        <div class="row">
          <div class="form-group-name">
            <label>First Name</label>
            <input
              type="text"
              placeholder="Enter your First Name"
              v-model="firstName"
              class=""
              :disabled="!isEditing"
            />
          </div>
          <div class="form-group-name">
            <label>Last Name</label>
            <input
              type="text"
              v-model="lastName"
              placeholder="Enter your Last Name"
              :disabled="!isEditing"
            />
          </div>
        </div>

        <div class="form-group-number">
          <label>Mobile Number<span>*</span></label>
          <div class="mobile-input">
            <span class="country-code">+1</span>
            <input
              type="text"
              v-model="mobile"
              placeholder="Enter Mobile Number"
              :disabled="!isEditing"
            />
          </div>
        </div>

        <div class="form-group">
          <label>Email ID</label>
          <input
            type="email"
            v-model="email"
            placeholder="Enter Email Id"
            :disabled="!isEditing"
          />
        </div>

        <div
          class="upload-section"
          @dragover.prevent="dragOver = true"
          @dragleave.prevent="dragOver = false"
          @drop.prevent="handleDrop"
          :class="{ 'drag-active': dragOver }"
          @click="triggerFileInput"
        >
          <div>
            <img
              :src="imageUrl || defaultImage"
              alt="profile"
              class="profile-pic"
            />
          </div>

          <div class="upload-box">
            <div class="upload-icon">
              <img src="../icons/uploadIcon.svg" alt="upload" />
            </div>
            <p>
              <span class="upload-link">Click to upload</span> or drag and drop
            </p>
            <p class="upload-hint">SVG, PNG, JPG or GIF (max. 800×400px)</p>
          </div>
        </div>

        <input
          type="file"
          ref="fileInput"
          style="display: none"
          accept="image/*"
          @change="handleFileSelect"
        />

        <div class="form-group">
          <label>Country</label>
          <select v-model="country" :disabled="!isEditing">
            <option>United States</option>
            <option>India</option>
            <option>United Kingdom</option>
          </select>
        </div>

        <div class="form-group">
          <label>Timezone</label>
          <select v-model="timezone" :disabled="!isEditing">
            <option>Pacific Standard Time (PST) UTC−08:00</option>
            <option>India Standard Time (IST) UTC+05:30</option>
            <option>Eastern Standard Time (EST) UTC−05:00</option>
          </select>
        </div>

        <div class="btn-group" v-if="isEditing">
          <button type="button" class="cancel-btn" @click="onCancel">
            Cancel
          </button>
          <button type="button" class="save-btn" @click="onSave">Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import userDetailsService from "@/services/userDetailsService";
import api from "@/services/userDetailsService";
import defaultProfile from "../icons/profilePic.svg";
export default {
  name: "ProfileForm",
  data() {
    return {
      isEditing: false,
      showEdit: true,
      userData: [],
      userId: localStorage.getItem("userid"),
      username: "",
      email: "",
      firstName: "",
      lastName: "",
      mobile: "",
      country: "",
      timezone: "",
      imageUrl: "",
      defaultImage: defaultProfile,
      dragOver: false,
      selectedFile: null,
    };
  },

  created() {
    this.loadData();
    this.fetchusername();
    this.fetchProfilePicture();
  },

  methods: {
    fetchusername() {
      const userid = localStorage.getItem("userid");

      if (!userid) {
        this.username = "unknown";
        this.email = "unknown";
        return;
      }

      axios
        .post("/api/getoneusers", { userID: userid })
        .then((response) => {
          this.username = response.data[0]?.userName || "unknown";
          this.email = response.data[0]?.email || "unknown";
        })
        .catch(() => {
          this.username = "unknown";
          this.email = "unknown";
        });
    },

    onClickedit() {
      this.isEditing = true;
      this.showEdit = false;
    },

    onCancel() {
      this.isEditing = false;
      this.showEdit = true;
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileSelect(event) {
      const file = event.target.files[0];
      this.processFile(file);
    },

    handleDrop(event) {
      this.dragOver = false;
      const file = event.dataTransfer.files[0];
      this.processFile(file);
    },

    processFile(file) {
      if (!file) return;
      this.selectedFile = file;
      this.imageUrl = URL.createObjectURL(file);
    },

    async loadData() {
      const res = await userDetailsService.getUserDetails({
        userID: this.userId,
      });

      this.userData = res.data;
      this.firstName = res.data.items[0].firstName;
      this.lastName = res.data.items[0].lastName;
      this.email = res.data.items[0].Email;
      this.mobile = res.data.items[0].phoneNumber;
      this.country = res.data.items[0].country;
      this.timezone = res.data.items[0].timeZone;
    },

    async uploadProfileImage() {
      if (!this.selectedFile) {
        return; // No image selected → skip upload
      }
      const formData = new FormData();
      formData.append("profilePic", this.selectedFile);
      // Check if user already has an image
      const existingImageRes = await axios.post("/api/imagelist", {
        userID: this.userId,
      });
      const existingImage = existingImageRes.data.items[0];
      let uploadedFileName = "";
      // Upload file
      const uploadRes = await axios.post(
        "/api/file/upload", // <-- use /api/file/upload
        formData
      );
      uploadedFileName = uploadRes.data.files?.[0]?.filename;
      // Update or insert
      if (uploadedFileName) {
        if (existingImage) {
          await axios.put("/api/editimage", {
            imageId: existingImage.imageId,
            userID: this.userId,
            filepath: uploadedFileName,
          });
        } else {
          await axios.post("/api/image", {
            userID: this.userId,
            filepath: uploadedFileName,
          });
        }
      }
      return;
    },

    async onSave() {
      try {
        const checkUser = await axios.post("/api/userdetailslist", {
          userID: this.userId,
        });

        const userDetails = checkUser.data?.items?.[0];

        if (!userDetails) {
          await axios.post("/api/adduserdetails", {
            firstName: this.firstName,
            lastName: this.lastName,
            phoneNumber: this.mobile,
            timeZone: this.timezone,
            country: this.country,
            userID: this.userId,
            Email: this.email,
          });
        } else {
          await axios.put("/api/updateuserdetails", {
            userDetailsID: userDetails.userDetailsID,
            firstName: this.firstName,
            lastName: this.lastName,
            phoneNumber: this.mobile,
            timeZone: this.timezone,
            country: this.country,
            userID: this.userId,
            Email: this.email,
          });
        }
        await this.uploadProfileImage();
        this.isEditing = false;
        this.showEdit = true;
      } catch (error) {
        console.error("API error:", error.message || error);
      }
    },

    async fetchProfilePicture() {
      const url = await api.getProfileImage(this.userId);

      if (url) {
        this.imageUrl = url;
      } else {
        if (import.meta.env.DEV) {
          console.log("No profile image found.");
        }
      }
    },
  },
};
</script>

<style scoped>
.profile-sec {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1440px;
  padding: 0 100px;
  margin-top: 50px;
}

.profile {
  display: flex;
  align-items: center;
}

.profile p {
  font-family: var(--font-primary);
  font-weight: var(--weight-semibold);
  line-height: 40px;
  font-size: var(--font-xxl);
  color: #181d27;
  margin-left: 26px;
}

.edit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #3467d5;
  width: 67px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #3467d5;
  padding: 10px 18px;
}
.edit-btn p {
  font-family: var(--font-primary);
  line-height: 24px;
  font-size: var(--font-md);
  font-weight: var(--weight-semibold);
  color: white;
  margin: 0 !important;
}
.edit-profile-container {
  border-radius: 16px;
  padding: 32px 40px;
  width: 646px;
  background: #fff;
  margin: 0 auto;
}

.profile-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.row {
  display: flex;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.form-group-name {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.form-group-name label {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  margin-bottom: 6px;
}
.form-group-number {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.form-group-number label {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  margin-bottom: 6px;
}
.form-group-number input {
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease;
  width: 566.88px;
}

.form-group label {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #414651;
  margin-bottom: 6px;
  line-height: 20px;
}
.form-group-name input {
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease;
}

.form-group input {
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease;
}
.profile-img {
  width: 192px;
  height: 192px;
  border-radius: 200px;
  border: 4px solid #e6ecfa;
  object-fit: cover;
}

.form-group select {
  width: 100%;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  color: #344054;
  background-color: white;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("../icons/down-arrow.svg");
  background-repeat: no-repeat;
  background-position: right 14px center;
  background-size: 16px;
}

.form-group select {
  padding-right: 40px;
}

.form-group input:focus,
.form-group select:focus {
  border-color: #0141ca;
}

.mobile-input {
  display: flex;
  align-items: center;
  gap: 8px;
}

.country-code {
  padding: 10px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
}

.upload-section {
  display: flex;
  gap: 16px;
}
.upload-section.drag-active {
  border-color: #3f51b5;
  background: #f3f6ff;
}
.profile-pic {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.upload-box {
  border: 1px solid #e9eaeb;
  border-radius: 8px;
  padding: 16px;
  flex: 1;
  text-align: center;
}

.upload-link {
  color: #0134a2;
  cursor: pointer;
  font-weight: 500;
}

.upload-hint {
  font-size: 12px;
  color: #444;
  margin-top: 4px;
}

.btn-group {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}

.cancel-btn {
  background: transparent;
  border: 1px solid #d5d7da;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  cursor: pointer;
  color: #414651;
  font-family: var(--font-primary);
  font-weight: 600;
  line-height: 20px;
}

.save-btn {
  background: #3467d5;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #3467d5;
  font-family: var(--font-primary);
  font-weight: 600;
  line-height: 20px;
}

.cancel-btn:hover {
  background: #f9fafb;
}

.save-btn:hover {
  background: #0136aa;
}
@media (max-width: 480px) {
  .profile-sec {
    display: flex;
    flex-direction: row;
  }
  .edit-profile-container {
    width: 100% !important;
    padding: 0 !important;
    border-radius: 12px;
  }
  .profile {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
  }
  .profile p {
    margin-left: 0px;
  }
  .profile-sec {
    display: flex;
    flex-direction: column;
    padding: 0px 50px;
  }
}
</style>
